export const validateLoginForm = ({ username, password }) => {
  const errors = {};
  if (!username.trim()) {
    errors.username = "Username is required";
  }
  if (!password) {
    errors.password = "Password is required";
  }
  return errors;
};

export const validateEventForm = (values) => {
  const errors = {};
  if (!values.name.trim()) {
    errors.name = "Event name is required";
  } else if (values.name.length > 100) {
    errors.name = "Event name must be 100 characters or fewer";
  }
  if (!values.start_datetime) {
    errors.start_datetime = "Start date and time is required";
  }
  if (!values.end_datetime) {
    errors.end_datetime = "End date and time is required";
  }

  if (
    values.start_datetime &&
    values.end_datetime &&
    new Date(values.end_datetime) < new Date(values.start_datetime)
  ) {
    errors.end_datetime = "End time cannot be before start time";
  }

  if (values.limit_per_ticket === "" || values.limit_per_ticket === null) {
    errors.limit_per_ticket = "Limit per ticket is required";
  } else if (Number(values.limit_per_ticket) < 0) {
    errors.limit_per_ticket = "Limit cannot be negative";
  } else if (!Number.isInteger(Number(values.limit_per_ticket))) {
    errors.limit_per_ticket = "Limit must be a whole number";
  }

  return errors;
};

export const validateSourceChannelForm = (values) => {
  const errors = {};
  if (!values.name.trim()) {
    errors.name = "Name is required";
  } else if (values.name.length > 50) {
    errors.name = "Name must be 50 characters or fewer";
  }

  if (!values.status) {
    errors.status = "Status is required";
  }

  if (!values.secret_key.trim()) {
    errors.secret_key = "Secret key is required";
  } else if (values.secret_key.length > 100) {
    errors.secret_key = "Secret key must be 100 characters or fewer";
  }

  return errors;
};
